module.exports = {
    viasName: () => {
        return[
            ["Variante Girardot Melgar", "Vía que ingresa al proyecto"]
        ]
    }
}